import { useCountdown } from '@/hooks/useCountdown';

export function StartOverlay({ startsAt, participantCount }: { startsAt: number | null; participantCount: number }) {
  const remaining = useCountdown(startsAt);
  return (
    <div className="fixed inset-0 z-30 flex items-center justify-center bg-primary-500/95 px-6 text-center text-white" role="dialog" aria-live="assertive">
      <div className="animate-pop-in">
        <div className="mb-4 text-6xl animate-bounce-soft" aria-hidden="true">
          🍽️
        </div>
        <h2 className="text-3xl font-extrabold">모두 모였어요!</h2>
        <p className="mt-2 text-lg text-primary-50">오늘의 점심 메뉴를 결정해볼까요?</p>
        {participantCount > 4 && (
          <p className="mx-auto mt-5 max-w-xs rounded-2xl bg-white/15 px-4 py-3 text-sm text-primary-50">
            한 게임에서는 최대 4명이 직접 선택해요.
            <br />
            다시하기를 누르면 순서를 새로 정합니다.
          </p>
        )}
        {remaining !== null && <p className="mt-6 text-sm text-primary-100">{remaining > 0 ? `${remaining}초 후 시작` : '시작합니다!'}</p>}
      </div>
    </div>
  );
}
